import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import LandingPage from "@/pages/LandingPage";

const PagoCompletado = lazy(() => import("@/pages/PagoCompletado"));
const PagoCancelado = lazy(() => import("@/pages/PagoCancelado"));
const MiCuenta = lazy(() => import("@/pages/MiCuenta"));
const AdminPanel = lazy(() => import("@/pages/AdminPanel"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Cargando = () => <div className="min-h-screen bg-[#0B1120]" data-testid="pagina-cargando" />;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Suspense fallback={<Cargando />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/pago-completado" element={<PagoCompletado />} />
              <Route path="/pago-cancelado" element={<PagoCancelado />} />
              <Route path="/mi-cuenta" element={<MiCuenta />} />
              <Route path="/admin/leads" element={<AdminPanel />} />
            </Routes>
          </Suspense>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
